import InView from 'inview';
import hoverintent from 'hoverintent';

class PipelineProgram {
	animationSpeed = 500

	constructor(el) {
		this.el = el;
		this.phaseBars = this.el.querySelectorAll('.phase__percentage--foreground');
		this.serviceLinks = this.el.querySelectorAll('.link-list a');
		this.phaseZero = this.el.querySelector('.phase--0');

		if (this.phaseBars.length) {
			let phaseTrack = 0;
			this.phaseBars.forEach((phaseBar) => {
				// Get the width as a percentage.
				const widthFactor = parseInt(phaseBar.dataset.width) * 0.01;
				/**
				 * Set the transition duration using the widthFactor to reduce time for phases
				 * less than 100% complete. This helps with phases with low completion percentages
				 * that would look to take a long time to animate.
				 */
				phaseBar.style.transitionDuration = `${this.animationSpeed * widthFactor}ms`;
				const isDisabled = phaseBar.closest('.phase--disabled');
				if (!isDisabled) {
					// Add a transition delay so phases animate in a sequence.
					phaseBar.style.transitionDelay = `${this.animationSpeed * phaseTrack}ms`;
					phaseTrack++;
				}
			});
		}

		// Add class for adding hover state to phaseBar.
		if (this.serviceLinks.length) {
			this.serviceLinks.forEach((serviceLink) => {
				hoverintent(serviceLink, () => {
					this.phaseZero.classList.add('hover');
				}, () => {
					this.phaseZero.classList.remove('hover');
				}).options({
					timeout: 100,
				});
			});
		}

		InView(this.el, this.handleInView);

		window.addEventListener('resize', this.updatePhaseWidths);
	}

	updatePhaseWidths = () => {
		window.requestAnimationFrame(() => {
			this.phaseBars.forEach((phaseBar) => {
				/**
				 * Only run this code if width styles haven't been applied or the width is not 100%,
				 * and never run it if the width is set to 0%. This prevents running extra code for no reason.
				 */
				if ((!phaseBar.style.width || phaseBar.style.width !== '100%') && phaseBar.style.width !== '0%') {
					// Get the width value set as data-attribute.
					const { width } = phaseBar.dataset;
					// Set the default width style as a percentage.
					let widthStyle = `${width}%`;
					// Get the parent .phase element and check if it is the current phase.
					const container = phaseBar.closest('.phase');
					if (container.classList.contains('phase--current')) {
						// Get phaseBar styles.
						const styles = window.getComputedStyle(phaseBar);
						// Get phaseBar border-radius as unitless number.
						const radius = parseFloat(styles.getPropertyValue('border-top-right-radius'));
						// Only proceed if we have a radius and it is greater than zero.
						if (radius && radius > 0) {
							// Get the width, in pixels, that the phase would animate to if the percentage widthStyle were applied.
							const percentageWidth = container.clientWidth * (width * 0.01);
							// If that width is less than the radius size, then change the widthStyle to be the radius value in pixels.
							// This fixes an issue where phases can look squished on smaller screens because the width is less than the radius.
							if (percentageWidth < radius) {
								widthStyle = `${radius}px`;
							}
						}
					}
					// Apply the width style.
					phaseBar.style.width = widthStyle;
				}
			});
		});
	}

	handleInView = (isInView, data) => {
		if (isInView && data.elementOffsetTopInViewHeight < data.inViewHeight / 2) {
			this.updatePhaseWidths();
		}
	}
}

const programs = [...document.querySelectorAll('.em-pipeline__program')];
if (programs.length) {
	embark.components.pipelines = programs.map((program) => new PipelineProgram(program));
}
